// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChangePassword_loginFormHeader__UHblo {
  color: var(--color-font-2);
  font-weight: bold;
  font-size: 22px;
  margin-bottom: 40px;
}

.ChangePassword_loginForm__o3hOC {
  margin: 40px;
}

.ChangePassword_input_container__OUCnz {
  width: 100% !important;
  margin: 10px 0px;
}

.ChangePassword_password_requirements__6ZzSE {
  margin-top: 10px;
  font-size: 12px;
}

.ChangePassword_password_requirements_error__tHu1W {
  margin-top: 10px;
  font-size: 12px;
  color: var(--color-theme-red);
}

.ChangePassword_btnContainer__X1NHi {
  margin-top: 40px;
  display: flex;
  justify-content: flex-end;
}

.ChangePassword_button__CBrGQ {
  width: 174px;
  height: 41px;
  border: 1px solid var(--color-theme-blue) !important;
  border-radius: 4px;
  background-color: var(--color-theme-white) !important;
  color: var(--color-theme-blue) !important;
  cursor: pointer;
  font-size: 16px;
}

.ChangePassword_button__CBrGQ:hover {
  color: var(--color-theme-white) !important;
  background-color: var(--color-theme-blue) !important;
}
`, "",{"version":3,"sources":["webpack://./src/@_components/ForgotPassword/ChangePassword/ChangePassword.module.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,oDAAoD;EACpD,kBAAkB;EAClB,qDAAqD;EACrD,yCAAyC;EACzC,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,oDAAoD;AACtD","sourcesContent":[".loginFormHeader {\n  color: var(--color-font-2);\n  font-weight: bold;\n  font-size: 22px;\n  margin-bottom: 40px;\n}\n\n.loginForm {\n  margin: 40px;\n}\n\n.input_container {\n  width: 100% !important;\n  margin: 10px 0px;\n}\n\n.password_requirements {\n  margin-top: 10px;\n  font-size: 12px;\n}\n\n.password_requirements_error {\n  margin-top: 10px;\n  font-size: 12px;\n  color: var(--color-theme-red);\n}\n\n.btnContainer {\n  margin-top: 40px;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.button {\n  width: 174px;\n  height: 41px;\n  border: 1px solid var(--color-theme-blue) !important;\n  border-radius: 4px;\n  background-color: var(--color-theme-white) !important;\n  color: var(--color-theme-blue) !important;\n  cursor: pointer;\n  font-size: 16px;\n}\n\n.button:hover {\n  color: var(--color-theme-white) !important;\n  background-color: var(--color-theme-blue) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loginFormHeader": `ChangePassword_loginFormHeader__UHblo`,
	"loginForm": `ChangePassword_loginForm__o3hOC`,
	"input_container": `ChangePassword_input_container__OUCnz`,
	"password_requirements": `ChangePassword_password_requirements__6ZzSE`,
	"password_requirements_error": `ChangePassword_password_requirements_error__tHu1W`,
	"btnContainer": `ChangePassword_btnContainer__X1NHi`,
	"button": `ChangePassword_button__CBrGQ`
};
export default ___CSS_LOADER_EXPORT___;
